import { Stack } from "@fluentui/react";
import React from "react";
import { CustomMultiItemCarousel } from "../../../../SharedComponents/CustomMultiItemCarousel/CustomMultiItemCarousel";
import { PromptCardGridProps } from "../../Interfaces/AIPlayground.interfaces";
import { PromptCard } from "./PromptCard";
import { useGetPromptLibraryQuery } from "../../../../slices/AIHub.slice";
import DisplayAPIsException from "../../../../BasicComponents/DisplayAPIsExceptionAlert";

export const PromptCardGrid: React.FC<PromptCardGridProps> = ({ onRunPrompt, prompts, useCarousel = false }) => {
  const { error, isError, isLoading } = useGetPromptLibraryQuery();

  if (!isLoading && isError) {
    return <DisplayAPIsException error={error} height={250} />;
  }

  if (useCarousel) {
    return (
      <CustomMultiItemCarousel
        items={prompts || []}
        renderItem={(item, idx) => <PromptCard {...item} key={item.id ?? idx} onRunPrompt={onRunPrompt} />}
      />
    );
  }

  return (
    <Stack
      horizontal
      wrap
      tokens={{ childrenGap: 24 }}
      styles={{
        root: {
          marginTop: 24
        }
      }}
    >
      {prompts?.map((prompt) => (
        <Stack
          key={prompt.id}
          styles={{
            root: {
              flexBasis: "calc(33.333% - 24px)",
              flexGrow: 1,
              marginBottom: 24,
              maxWidth: 400,
              minWidth: 260
            }
          }}
        >
          <PromptCard {...prompt} onRunPrompt={onRunPrompt} />
        </Stack>
      ))}
    </Stack>
  );
};
